"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MfaTokenToJSON = exports.MfaTokenFromJSONTyped = exports.MfaTokenFromJSON = void 0;
function MfaTokenFromJSON(json) {
    return MfaTokenFromJSONTyped(json, false);
}
exports.MfaTokenFromJSON = MfaTokenFromJSON;
function MfaTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
    };
}
exports.MfaTokenFromJSONTyped = MfaTokenFromJSONTyped;
function MfaTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
    };
}
exports.MfaTokenToJSON = MfaTokenToJSON;
//# sourceMappingURL=MfaToken.js.map